import { Typography } from '@weareopenr/component-library';
import styles from './AutocompleteOptionWithRanges.module.scss';

interface OptionWithRanges {
  name: string;
  ranges?: { name: string }[];
}

interface AutocompleteOptionWithRangesProps {
  option: OptionWithRanges;
}

export const AutocompleteOptionWithRanges = ({ option }: AutocompleteOptionWithRangesProps) => {
  const rangeNames = option.ranges?.map((range) => range.name);

  return (
    <div className={styles['option-content']}>
      <Typography size="medium">
        <span title={option.name}>{option.name}</span>
      </Typography>
      {rangeNames && rangeNames.length > 0 ? (
        <Typography size="small" className={styles['range-subtitle']}>
          <span title={rangeNames.join('\r\n')}>{rangeNames.join(', ')}</span>
        </Typography>
      ) : (
        <Typography size="small" className={styles['no-range']}>
          No Range
        </Typography>
      )}
    </div>
  );
};
